import React, { Component } from 'react';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  margin-left: 50px;
  border: 2px solid #D8B084;
  border-radius: 3px;
  height: 46px;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 18px;
  padding: 0 12px;
  position: relative;
  width: 120px;
  cursor: pointer;
  @media (max-width: 789px) {
    width: 240px;
    margin: 0;
  }
  &:hover,
  &.active {
    .selected {
      &:after {
        transform: rotate(180deg);
      }
    }
    .holder {
      display: block;
    }
  }
  .selected {
    font-weight: 600;
    position: relative;
    width: 100%;
    &:after {
      position: absolute;
      content: ' ';
      right: -2px;
      top: 9px;
      width: 0; 
      height: 0; 
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #fff;
    }
  }
  .holder {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    @media (min-width: 789px) {
      top: 46px;
    }
    @media (max-width: 789px) {
      bottom: 42px;
    }
    ul {
      position: relative;
      width: 100%;
      background: #2D2D2C;
      margin: 0;
      padding: 3px 0 0;
      top: -3px;
      left: -2px;
      border: 2px solid #D8B084;
      @media (min-width: 789px) {
        border-top: 0;
        border-radius: 0 0 3px 3px;
      }
      @media (max-width: 789px) {
        border-bottom: 0;
        border-radius: 3px 3px 0 0;
      }
      z-index: 2;
      li {
        display: block;
        padding: 10px 12px;
        @media (min-width: 789px) {
          border-top: 1px solid #D8B084;
        }
        @media (max-width: 789px) {
          border-bottom: 1px solid #D8B084;
        }
      }
    }
  }
`

class LangSelect extends Component {
  state = {
    active: false,
  }
  toggleActive = () => {
    if (window.innerWidth < 789)
      this.setState({active: !this.state.active});
  }
  render = () => {
    const { language, setLanguage } = this.context;
    return (
      <Container onClick={ this.toggleActive } className={ this.state.active && 'active' }>
        <span className="selected">
          { language === 'pt-br' && 'Português' }
          { language === 'en-us' && 'English' }
          { language === 'es-es' && 'Español' }
        </span>
        <i></i>
        <div className="holder">
          <ul>
            <li onClick={ () => setLanguage('pt-br') } >
              <span>Português</span>
            </li>
            <li onClick={ () => setLanguage('en-us') } >
              <span>English</span>
            </li>
            <li onClick={ () => setLanguage('es-es') } >
              <span>Español</span>
            </li>
          </ul>
        </div>
      </Container>
    )
  }
}

LangSelect.contextType = LanguageContext;

export default LangSelect;
